import { render, staticRenderFns } from "./tripleCotasking-add.vue?vue&type=template&id=5557ca48&scoped=true&"
import script from "./tripleCotasking-add.vue?vue&type=script&lang=js&"
export * from "./tripleCotasking-add.vue?vue&type=script&lang=js&"
import style0 from "./tripleCotasking-add.vue?vue&type=style&index=0&id=5557ca48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5557ca48",
  null
  
)

export default component.exports